import type { ModuloWeb } from '../../nucleo/modulos-web';
import { Arquivos } from './Arquivos';
import { Assinaturas } from './Assinaturas';
import { Contratos } from './Contratos';
import { i18n } from './i18n';
import { buscaDocumentos } from './busca-global';

/**
 * Pacote 2 (onda 1a): Documentos e assinatura, no menu Cadastros (grupo próprio, com o nome do módulo). Nasce desligado no
 * Principal e ligado no Sandbox (liberado por workspace).
 */
const modulo: ModuloWeb = {
  slug: 'documentos',
  menu: 'cadastros',
  ordem: 60,
  abas: [
    { chave: 'arquivos', permissao: 'documentos.ver', componente: Arquivos, posicao: 110 },
    { chave: 'contratos', permissao: 'documentos.ver', componente: Contratos, posicao: 120 },
    { chave: 'assinaturas', permissao: 'documentos.ver', componente: Assinaturas, posicao: 130 },
  ],
  i18n,
  // Lista de 30/10 (item 10): grupos da busca da barra superior.
  buscaGlobal: buscaDocumentos,
};

export default modulo;
